import { gql } from '../../__generated__';

gql(`
  fragment FacilityFields on Facility {
    id
    name
  }
`);

export const GET_FACILITIES = gql(`
  query GetFacilities($after: String, $first: Int) {
    getFacilities(after: $after, first: $first) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          ...FacilityFields
        }
      }
    }
  }
`);

export const UPSERT_FACILITY = gql(`
  mutation UpsertFacility($input: UpsertFacilityInput!) {
    upsertFacility(input: $input) {
      ...FacilityFields
    }
  }
`);

export const DELETE_FACILITY = gql(`
  mutation DeleteFacility($id: String!) {
    deleteFacility(id: $id)
  }
`);
